import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Alert } from 'react-bootstrap';
import ConfigurerCotisation from './configurerCotisation';
import GestionAffichage from './gestionAffichage';


function GestionCotisation(props) {
  const [cotisation, setCotisation] = useState(null);
  const [configuration,setConfiguration] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/cotisation/verification/equipe/${props.userData.user.donnée.results[0].id_equipe}`,
          {
            withCredentials: true 
          }
        );
        setCotisation(response.data);
        setIsLoading(false);

        setError(null);
      } catch (error) {
        if (error.response.data.errorType === "COTISATION_NON_CONFIGUREE") {
            setConfiguration(true)
        }
        else if (error.response) {
            
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [apiUrl, props]);


  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }
return (
  <>
    {error && <Alert variant="danger">{error}</Alert>}
    {configuration && <ConfigurerCotisation userData={props.userData}/>}
    {cotisation && <GestionAffichage userData={props.userData} cotisation={cotisation}/>}
  </>
);
}

export default GestionCotisation;